(() => {
  'use strict';

  /**
   * Convert a Datanorm article number to the
   * corresponding Shopify SKU.
   *
   * Examples:
   * 06938977     -> 6938977
   * 0006938977   -> 6938977
   * 001234       -> 1234
   */
  function normalizeDatanormQuery(value) {
    const query = (value || '').trim();

    // Only pure numeric values starting with one or more zeros
    if (!/^0+\d+$/.test(query)) {
      return null;
    }

    const normalized = query.replace(/^0+/, '');

    if (!normalized) {
      return null;
    }

    return {
      original: query,
      normalized
    };
  }

  /**
   * Find the actual search input belonging to a form.
   */
  function getSearchInput(form) {
    if (!form) return null;

    return form.querySelector(
      'input[name="q"], input[type="search"]'
    );
  }

  /**
   * Normalize immediately BEFORE the search form
   * is submitted.
   *
   * Capture phase is important because this should
   * run before normal Findter/theme submit handlers.
   */
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement)) {
        return;
      }

      const input = getSearchInput(form);

      if (!input) {
        return;
      }

      const result = normalizeDatanormQuery(input.value);

      if (!result) {
        return;
      }

      const { original, normalized } = result;

      console.debug(
        '[Datanorm Search]',
        original,
        '→',
        normalized
      );

      /**
       * q = actual Shopify / Findter search query
       */
      input.value = normalized;

      /**
       * display_q = what the customer originally entered
       */
      let displayInput = form.querySelector(
        'input[name="display_q"]'
      );

      if (!displayInput) {
        displayInput = document.createElement('input');
        displayInput.type = 'hidden';
        displayInput.name = 'display_q';
        form.appendChild(displayInput);
      }

      displayInput.value = original;
    },
    true
  );
})();